import { DataSourceExecutionEvent, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutVoidChecks } from "./autogen/AutogenLayoutVoidChecks";
import { ModelSettlement } from "./models/ModelSettlement";
import { ModelDrsPendingDeduct } from "./models/ModelDrsPendingDeduct";
import { ModelRow, StringUtil } from "@mcleod/core";

export class VoidChecks extends AutogenLayoutVoidChecks {
    public selectedRows: ModelRow[] = [];
    public idString: string = "record_id";

    onLoad(): void | Promise<void> {
        this.tableVoidChecks.addRowDisplayListener(async (event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow() as TableRow;
            const imagePayeeUnpostedPayments = tableRow.findComponentById("imagePayeeUnpostedPayments");
            if (imagePayeeUnpostedPayments) {
                let tooltipMessage = "";
                const settlementRecordsForPayee = (await new ModelSettlement().search({ check_number: tableRow.data.get("check_number") })).modelRows;
                const payAdjustmentRecordsForPayee = (await new ModelDrsPendingDeduct().search({ check_number: tableRow.data.get("check_number") })).modelRows;
                const allSettlementRecordsSelected = settlementRecordsForPayee.every(record => this.selectedRows.find(row => row.get("check_number") === record.get("check_number") && row.get(this.idString) === record.get("id")));
                const allPayAdjustmentRecordsSelected = payAdjustmentRecordsForPayee.every(record => this.selectedRows.find(row => row.get("check_number") === record.get("check_number") && row.get(this.idString) === record.get("id")));
                const unSelectedCheckRecordsExist = !allSettlementRecordsSelected || !allPayAdjustmentRecordsSelected;
                if (unSelectedCheckRecordsExist) {
                    tooltipMessage += "- This unposted payment includes payable records that were not selected.";
                }
                const nonProcessSelectedRecordsExist: boolean = this.selectedRows.some((selectedRow) => {
                    const selectedPayeeId = selectedRow.get("payee_id");
                    return tableRow.data.get("payee_id") === selectedPayeeId && selectedRow.get("process_status") !== "C";
                });
                if (nonProcessSelectedRecordsExist) {
                    tooltipMessage += (!StringUtil.isEmptyString(tooltipMessage) ? "\n" : "") + "- Selected records for payee have not been included on an unposted payment.";
                }
                imagePayeeUnpostedPayments.tooltip = tooltipMessage;
                imagePayeeUnpostedPayments.visible = unSelectedCheckRecordsExist || nonProcessSelectedRecordsExist;
            }
        });
    }

    /** This is an event handler for the afterExecution event of sourceDrsCheck. */
    sourceDrsCheckAfterExecution(event: DataSourceExecutionEvent) {
        this.tableVoidChecks.selectedRows = this.tableVoidChecks.rows;
    }
}
